import { createApp } from 'vue'
import App from '../src/TSXVisualisationApp.vue'

const app = createApp(App)
app.mount('#app')
